import React from 'react';
import pcg_photo1 from '../../../assets/images/gamesplus.webp';
import pcg_photo1_safari from '../../../assets/images/gamesplus.jpg';

const AboutGeneral = () => (
  <div className='aboutus__general__container'>
    <div className='aboutus__general__location'>
      <picture id='picture1'>
          <source srcSet={pcg_photo1} type='image/webp'/>
          <source srcSet={pcg_photo1_safari} type='image/png'/>
          <img className="papercactus__aboutus-general-image" alt="pc_logo"/>
      </picture>
      <iframe 
          title="background-aboutus-video"
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3271.2715227381314!2d138.6000671!3d-34.9247267!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ab0cf17086cd54d%3A0x12387f5f7c07d0ce!2sGame%20Plus!5e0!3m2!1sen!2sjp!4v1715096168271!5m2!1sen!2sjp" 
          style={{width:"400px", height:"300px", border:"0", paddingRight: '20px'}} 
          allowFullScreen 
          loading="lazy" 
          referrerPolicy="no-referrer-when-downgrade">
      </iframe>
      <div className='aboutus__location_text'>
          <span>Paper Cactus Games</span>
          <span>Games Plus</span>
          <span>Level 2/44 Pirie St</span>
          <span>Adelaide, South Australia 5000 </span>
          <span> Australia</span>
          <br/>
          <a className='aboutus__contact-link' href='mailto:contact@papercactusgames.com'>contact@papercactusgames.com</a>
      </div>
    </div>
  </div>
);

export default AboutGeneral;
